import { useState } from "react";
import { InterestsSheet } from "../interests/InterestsSheet";
import { useConsumeQueryFlag } from "../../domains/app/hooks/useConsumeQueryFlag";

/**
 * Opens the simple topic picker (`InterestsSheet` → `TopicsInterestsEditor`) on
 * arrival at `/discovery?openInterests=1` — the destination of the
 * profile-completion `nudge-topics` push. This is the plain chip picker, NOT the
 * agent-assisted profiling conversation (`openPreferences=1`).
 *
 * The flag is consumed one-shot (`useConsumeQueryFlag` strips it from the URL on
 * mount); `open` latches it into `useState`, so stripping the URL keeps the
 * sheet up and a later history-return can't re-open a dismissed sheet. Rendered
 * only for the deep-link — the manual entry point is the tab-bar gear chip
 * (`DiscoveryInterestsSheet`).
 */
function DiscoveryInterestsDeepLink(): React.JSX.Element | null {
  const forceOpen = useConsumeQueryFlag("openInterests");
  const [open, setOpen] = useState(forceOpen);
  if (!open) return null;
  return (
    <InterestsSheet
      isOpen
      onClose={() => {
        setOpen(false);
      }}
    />
  );
}

export { DiscoveryInterestsDeepLink };
